/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PlcHttpConfig, PlcHttpConfigToken } from './services.models';

import { User } from '../models/user.entity';
import { UpdateUserRequest } from '../models/update-user.request';

export type UsersFindOnePathVariables = { id: string };
export type UsersUpdatePathVariables = { id: string };

@Injectable()
export class UsersService {
	constructor(
		@Inject(PlcHttpConfigToken) private config: PlcHttpConfig,
		private http: HttpClient,
	) {}

	public findOne(path: UsersFindOnePathVariables): Observable<User> {
		return this.http.get<User>(
			`${this.config.apiUrl}/api/v2/private/users/${path.id}`,
		);
	}

	public update(
		path: UsersUpdatePathVariables,
		body: UpdateUserRequest,
	): Observable<User> {
		return this.http.patch<User>(
			`${this.config.apiUrl}/api/v2/private/users/${path.id}`,
			body,
		);
	}
}
